export const BLASTS_FEATURE_NAME = 'Blasts'
